import { jsx as _jsx } from "react/jsx-runtime";
import useTitle from '~/hooks/useDocTitle';
const Screen = ({ children, docTitle = 'CSS Phoenix', setScrollPosition }) => {
    useTitle(docTitle);
    return (_jsx("div", { className: "h-full w-full overflow-auto", onScroll: (event) => {
            const scrollTop = event.target.scrollTop;
            if (setScrollPosition) {
                setScrollPosition(scrollTop);
            }
        }, children: children }));
};
export default Screen;
